import { FASTElement } from "@microsoft/fast-element";
/**
 * Simple Table
 * @summary A thin shell around native `<table>` that standardizes Fluent styling, RTL/high-contrast, and accessibility—without taking control of data, templates, or rendering.
 *
 * @example
 * ```html
 * <fabric-simple-table>
 *   <table>
 *     <caption>Account Overview</caption>
 *     <thead>
 *       <tr>
 *         <th scope="col">Account</th>
 *         <th scope="col">Owner</th>
 *         <th scope="col">Status</th>
 *       </tr>
 *     </thead>
 *     <tbody>
 *       <tr>
 *         <td>Contoso</td>
 *         <td>A. Lee</td>
 *         <td><span class="badge badge--warning">Pending</span></td>
 *       </tr>
 *     </tbody>
 *   </table>
 * </fabric-simple-table>
 * ```
 *
 * @extends FASTElement
 * @tagname fabric-simple-table
 * @public
 */
export class SimpleTable extends FASTElement {
    /**
     * Lifecycle method called when the element is connected to the DOM.
     * Applies the microsoft-fabric-ux-fabric-simple-table class to child table elements.
     * @public
     */
    connectedCallback() {
        super.connectedCallback();
        this.applyTableClass();
    }
    /**
     * Applies the styling class to child table elements.
     * @public
     */
    applyTableClass() {
        // Use :scope > table to only select direct child table elements
        const tableElement = this.querySelector(":scope > table");
        if (!tableElement) {
            console.warn("fabric-simple-table: No direct child <table> element found. This component requires a <table> as a direct child.");
            return;
        }
        tableElement.classList.add("microsoft-fabric-ux-fabric-simple-table");
    }
}
//# sourceMappingURL=simple-table.js.map